import PropTypes from "prop-types";
import React from "react";
import Popup from "reactjs-popup";
import { Button } from "@opendate-app/setlist";

const TimeCascadeModal = ({ cascade, onAccept, onSkip, submitting }) => {
  if (!cascade || !cascade.moves || cascade.moves.length === 0) return null;

  return (
    <Popup open modal closeOnDocumentClick={false} onClose={submitting ? undefined : onSkip}
      contentStyle={{ width: "440px", borderRadius: "12px", padding: "20px" }}>
      <div className="sd-preset-modal">
        <h3>Move Doors and Event End too?</h3>
        <p>You changed Event Start. Update these to match?</p>
        {cascade.moves.map((m) => (
          <p key={m.id}><strong>{m.name}</strong> → {m.proposed_label}</p>
        ))}
        {cascade.overridden && cascade.overridden.length > 0 && (
          <p>{cascade.overridden.join(" and ")} looks custom — left unchanged.</p>
        )}
        <div className="sd-preset-actions">
          <Button variant="secondary" onClick={onSkip} disabled={submitting}>Skip</Button>
          <Button variant="primary" onClick={onAccept} disabled={submitting}>{submitting ? "Applying…" : "Apply"}</Button>
        </div>
      </div>
    </Popup>
  );
};

TimeCascadeModal.propTypes = {
  cascade: PropTypes.shape({
    moves: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number, name: PropTypes.string,
      proposed_start_time: PropTypes.string, proposed_label: PropTypes.string,
    })),
    overridden: PropTypes.arrayOf(PropTypes.string),
  }),
  onAccept: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

export default TimeCascadeModal;
